import React from "react";
import DiscussionList from "./Discussion-list";
import DiscussionDetail from "./Discussion-detail";
import PhoneNumber from "./../../../Common/phoneNumber";
import { connect } from "react-redux";
import {
  getDiscussionThreadsAction,
  getMessagesAction,
  sendReplyAction,
  resendMsgAction
} from "../../../../actions/DiscussionActions";
import noRecord from "./../../../../assets/img/no-record.png";

var _ = require("lodash");

class Discussion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleDiscussion: "",
      threadList: [],
      messageList: undefined,
      name: "",
      threadObj: undefined,
      showLoader: false,
      from: undefined
    };
    this.toggleDiscussion = this.toggleDiscussion.bind(this);
    this.getMessageList = this.getMessageList.bind(this);
    this.sendReply = this.sendReply.bind(this);
    this.getDiscussionThreads = this.getDiscussionThreads.bind(this);
  }

  componentWillMount() {
    this.setState({
      showLoader: true
    });
    if (!!this.props.form) {
      this.setState({ from: this.props.form })
    }
    this.getDiscussionThreads(1);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!!nextProps.form) {
      this.setState({ from: nextProps.from })
    }
  }

  /**
   * @desc Call api for contacts list or dicussion thread list
   * @param {*} obj 
   */
  getDiscussionThreads(obj) {
    this.props.getDiscussionThreadsAction(this.props.transactionId).then(res => {
      if (this.props.threads !== undefined) {

        let threadList = this.props.threads.filter(e => {
          return ((e.email === undefined) || (e.email !== undefined))
        });

        //sort data based on last msg time
        threadList = _.sortBy(threadList, 'receiveTime');
        this.setState({ threadList: threadList });

        //Call msg list api for first converstaion
        if (threadList.length > 0) {

          let firstContact = threadList[0];
          if (obj != 1) {
            //load opened thread data
            firstContact = obj;
          }

          if (!!this.state.from) {
            firstContact = this.state.from;
          }

          //get discussion from notification
          if (this.props.history.location.discussion) {
            firstContact = this.props.history.location.from;
          }

          if (firstContact._id !== undefined && firstContact._id != "") {
            //pass email as identifier and email value of contact as value
            this.getMessageList(
              "id",
              {
                email: firstContact.email.address,
                mobile: firstContact.mobileNumber
              },
              firstContact
            );
            if (this.props.messages !== undefined) {
              this.setState({ messageList: this.props.messages });
            }
          } else if (firstContact.email !== undefined && firstContact.email.address !== "") {
            //pass email as identifier and email value of contact as value
            this.getMessageList(
              "email",
              firstContact.email.address,
              firstContact
            );
            if (this.props.messages !== undefined) {
              this.setState({ messageList: this.props.messages });
            }
          } else {
            //pass mobile as identifier and mobile number of contact as value
            this.getMessageList(
              "mobile",
              firstContact.mobileNumber,
              firstContact
            );
            if (this.props.messages !== undefined) {
              this.setState({ messageList: this.props.messages });
            }
          }
        } else {
          this.setState({ showLoader: false });
        }
      }
    });
  }

  toggleDiscussion(data) {
    if (window.innerWidth < 800) {
      if (data == 0) {
        this.setState({ toggleDiscussion: "open" });
      } else {
        this.setState({ toggleDiscussion: "" });
      }
    }
  }

  /**
   * @desc Get messages based on identifier and value
   * @param {*} identifier 
   * @param {*} value 
   * @param {*} thread 
   */
  getMessageList(identifier, value, thread) {
    this.props
      .getMessagesAction(this.props.transactionId, identifier, value)
      .then(res => {
        if (this.props.messages !== undefined) {
          this.setState({ showLoader: false });
          let messageList = '';

          if (!!thread.email && thread.email.address === localStorage.getItem('EMAIL')) {
            messageList = this.props.messages.filter(e => {
              return (
                e.communicationReferralNo !== "" || e.from == thread.mobileNumber
              );

            });

          } else {
            messageList = this.props.messages
          }
          this.setState({
            messageList: messageList,
            threadObj: thread
          });

          //Set name for message thread
          let name = thread.firstname != "" ? thread.firstname : "";

          if (thread.lastname != "" && thread.lastname !== undefined) {
            name = name != "" ? name + " " + thread.lastname : thread.lastname;
          }
          if (thread.email !== undefined && name == "") {
            name = thread.email.address;
          } else {
            if (name == "") {
              name = <PhoneNumber phoneNumber={thread.mobileNumber} />;
            }
          }
          this.setState({ name: name });

          let threadList = this.state.threadList;
          threadList.map((th, i) => {
            if (JSON.stringify(th) === JSON.stringify(thread)) {
              th.unreadCount = 0;
            }
          });
          this.setState({ threadList });
        }
      });
  }

  sendReply = (msg, threadObj, type) =>
    new Promise((resolve, reject) => {
      let transactionId = this.props.transactionId;
      let to = (threadObj.mobileNumber !== undefined) ? threadObj.mobileNumber : "";
      if (to == "") {
        to = (threadObj.email !== undefined) ? threadObj.email.address : "";
      }

      let data = {
        to: to,
        firstname: threadObj.firstname,
        lastname: threadObj.lastname,
        email: (threadObj.email !== undefined) ? threadObj.email.address : "",
        userID: threadObj._id,
        description: msg,
        transactionId: transactionId,
        communicationType: type
      };
      this.props.sendReplyAction(data).then(res => {
        if (this.props.replyRes) {
          this.getDiscussionThreads(threadObj);
          resolve({ status: true });
        }
      });
    });

  /**
   * @desc Resend message api call
   */
  resendMsg = (discussionId, threadObj) =>
    new Promise((resolve, reject) => {
      let data = {
        discussionId: discussionId
      };
      this.props.resendMsgAction(data).then(res => {
        if (this.props.resendRes) {
          this.getDiscussionThreads(threadObj);
          resolve({ status: true });
        }
      });
    });

  render() {
    return (
      // discussion-main-mobile
      <div className={this.state.toggleDiscussion + " discussion-main"}>
        {this.state.showLoader ? (
          <div className="page-loader fixed">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <>
            {this.state.threadList == 0 ? (
              <div className="no-transaction no-record">
                <div className="no-transaction-inner">
                  <img src={noRecord} alt="no record" />
                  <p>No Discussion</p>
                </div>
              </div>
            ) : (
              <>
                <DiscussionList
                  DiscussionListMethod={data => this.toggleDiscussion(data)}
                  threadList={this.state.threadList}
                  getMessageList={this.getMessageList}
                />
                <DiscussionDetail
                  key={"msg-" + this.state.name}
                  DiscussionDetailMethod={data => this.toggleDiscussion(data)}
                  messages={this.state.messageList}
                  name={this.state.name}
                  threadObj={this.state.threadObj}
                  sendReply={this.sendReply}
                  resendMsg={this.resendMsg}
                  transactionData={this.props.transactionData}
                />
              </>
            )}
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    threads: state.reducer.threads,
    messages: state.reducer.messages,
    replyRes: state.reducer.replyRes,
    resendRes: state.reducer.rresendRes
  };
};

export default connect(mapStateToProps, {
  getDiscussionThreadsAction,
  getMessagesAction,
  sendReplyAction,
  resendMsgAction
})(Discussion);
